import { ReactNode } from "react"
import { useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router-dom"
import { RootState } from "../redux/store"

type ProtectedRouteProps = {
  children?: ReactNode
  requiredRoles?: string[]
}

const ProtectedRoute = ({ children, requiredRoles = [] }: ProtectedRouteProps) => {
  const userLoggedIn = useSelector((state: RootState) => state.auth.userLoggedIn)
  const permissions = useSelector((state: RootState) => state.permissions)

  const hasAccess = requiredRoles.length === 0 || requiredRoles.some((role) => permissions[role])

  if (!userLoggedIn) {
    return <Navigate to="/login" replace />
  }

  if (!hasAccess) {
    return <Navigate to="/no-access" replace />
  }

  return children ? children : <Outlet />
}

export default ProtectedRoute
